import { useMachine } from '@minutemailer/state';
import appMachine from '@states/app';

export default function useApp() {
    const [{ info }] = useMachine(appMachine, null, ['info']);

    return info;
}
